import { useFetcher } from 'react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { protectedResourceLoader } from '~/shell/utils/authUtil.server';
import { fetchInventoryLookups } from '~/features/inventory/inventory.server';
import { TgArea } from '~/common/types/area';
import { promiseHash } from 'remix-utils/promise';
import { getLatestInventoryIdFromContext } from '~/shell/globalContext.ts';

export const loader = protectedResourceLoader(async ({ api, url }) => {
  try {
    const mainArticleIdParam = url.searchParams.get('mainArticleId');
    const mainArticleId = mainArticleIdParam ? Number.parseInt(mainArticleIdParam, 10) : undefined;

    const results = await promiseHash({
      invenories: fetchInventoryLookups(api, mainArticleId),
      latestInventoryId: getLatestInventoryIdFromContext()
    });

    return {
      latestInventoryId: results.latestInventoryId,
      inventories: results.invenories,
      ok: true
    };
  } catch {
    return { ok: false };
  }
});

export function useAllInventories(articles: { mainArticleId: number; isExternalArticle: boolean; quantity: number }[]) {
  const { load, data, state } = useFetcher<typeof loader>();
  const { i18n } = useTranslation();

  let url = `/${i18n.language}/${TgArea}/inventory/all`;

  if (articles.length === 1) {
    url = `${url}?mainArticleId=${articles[0].mainArticleId}`;
  }

  useEffect(() => {
    load(url);
  }, [i18n.language, load, url]);

  return {
    inventories: data?.inventories ?? [],
    latestInventoryId: data?.latestInventoryId,
    isLoading: state === 'loading',
    ok: data?.ok
  };
}
